import { useMemo } from 'react';
import { CommonHeadingTxt } from '../Text/Text';
import AdvancedTable from '../AdvancedTable';

const PatientList = ({ patients }) => {
  // Memoize columns
  const columns = useMemo(
    () => [
      {
        name: 'Patient Name',
        selector: 'name',
        sortable: true,
      },
      {
        name: 'Gender',
        selector: 'gender',
        width: 100,
        sortable: true,
      },
      {
        name: 'Email',
        selector: 'email',
      },
      {
        name: 'Phone',
        selector: 'phoneNo',
        width: 130,
      },
      {
        name: 'DOB',
        selector: 'birthDate',
        width: 120,
        cell: row => {
          if (!row.birthDate) return '---';
          const date = new Date(row.birthDate);
          return date.toISOString().split('T')[0];
        },
      },
      {
        name: 'Reg. No',
        selector: 'registrationNo',
        width: 120,
      },
    ],
    []
  );

  // Fetch data function
  const fetchPatients = useMemo(() => {
    return async ({ page, perPage }) => {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      const data = patients || [];
      return {
        data: data.slice(start, end),
        total: data.length,
      };
    };
  }, [patients]);

  return (
    <div className="card mb-3 mb-xl-4 h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <CommonHeadingTxt Text="Enrolled Patient List" />
        </div>
        <AdvancedTable
          resource="enrolled-patients"
          columns={columns}
          fetchData={fetchPatients}
          enableSearch={false}
          enableFilters={false}
          enableExport={false}
          enableToolBar={false}
          enableSummary={false}
          defaultPageSize={5}
          tableId="enrolled-patients-table"
          scroll={{ x: 400 }}
        />
      </div>
    </div>
  );
};

export default PatientList;
